import { AdvancedControls } from "./AudioVideoSelector";

function Settings(props) {
  const meeting = props.meeting;
  const handleCameraChanged = props.handleCameraChanged;
  const handleMicChanged = props.handleMicChanged;
  const handleSpeakerChanged = props.handleSpeakerChanged;

  return (
    <div className="bg-white w-full h-full p-4 relative">
      <h1 className="text-lg font-bold">Settings</h1>

      <AdvancedControls
        handleCameraChanged={handleCameraChanged}
        handleMicChanged={handleMicChanged}
        handleSpeakerChanged={handleSpeakerChanged}
        meeting={meeting}
        accordionOpen={true}
        accordionHeading="Show Audio/Video Controls"
      />
    </div>
  );
}

export default Settings;
